import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { styledWithTheme } from "../../context";
var InputSegment = styledWithTheme('input')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;  \n  box-sizing: content-box;\n  text-align: center;\n  border: 0;\n  padding: 0 1px;\n  margin: 0;\n  width: ", ";\n\n  font-size: inherit;\n  font-family: ", ";\n  color: ", ";\n  background-color: transparent;\n\n  cursor: ", ";\n  caret-color: transparent;\n  user-select: none;\n  ::selection {\n    background-color: transparent;\n  }\n\n  :focus {\n    background-color: ", ";\n    color: ", ";\n    \n    // To make the indication clear in High Contrast mode in Windows\n    outline: 2px solid ", ";\n    z-index: 0;\n\n    ::placeholder {\n      color: ", ";\n    }\n  }\n  outline: none;\n\n  ::placeholder {\n    color: ", ";\n  }\n  ::-moz-placeholder { /* Firefox 19+ */\n    color: ", ";\n    opacity: 1;\n  }\n  :placeholder-shown {\n    font-style: italic;\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return width ? width + 'px' : 'initial';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.selectors.fontFamily('primary');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.selectors.color('neutral90');
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'not-allowed' : 'default';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.selectors.color('primary70');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.selectors.color('neutral0');
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.selectors.color('primary70');
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.selectors.color('neutral0');
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.selectors.color('neutral70');
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.selectors.color('neutral70');
});
export default InputSegment;